import { createHash, randomBytes } from 'node:crypto';
import {
  base64UrlEncode,
  E2EE_ALG,
  E2EE_KEY_BYTES,
  type E2eeKeyRecord,
} from '@buildautomaton/e2ee';

export type CliE2eeKey = E2eeKeyRecord;

export function createE2eeKeyRecord(name: string): CliE2eeKey {
  const raw = randomBytes(E2EE_KEY_BYTES);
  const digest = createHash('sha256').update(raw).digest();
  return {
    id: base64UrlEncode(digest.subarray(0, 16)),
    name: name.trim() || 'BuildAutomaton E2EE key',
    a: E2EE_ALG,
    k: base64UrlEncode(raw),
    createdAt: new Date().toISOString(),
  };
}
